import { Navigate } from "react-router-dom";
import { LOGIN_ROUTE } from "../routes/vendor/vendorRoutes";
import authManager from "../utils/vendorManager/authManager";

const VendorManager = ({ children }) => {
  if (authManager.hasVendorManagerAccessToken()) {
    return children;
  } else {
    return <Navigate to={LOGIN_ROUTE} replace />;
  }
};

export default VendorManager;
